import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cc0008',
    ecrans: ['00-2'],
    params: ['id']
});